// import React from "react";

// const GRID_SIZE = 100;

// export default function WaffleChart({
//   title,
//   positive,
//   negative,
//   mode = "posneg",   // "posneg" | "total"
//   data = []
// }) {
//   const posCount = Math.round(positive);
//   const negCount = Math.round(negative);
//   const neutralCount = Math.max(0, GRID_SIZE - posCount - negCount);

//   const cells = [
//     ...Array(posCount).fill("positive"),
//     ...Array(negCount).fill("negative"),
//     ...Array(neutralCount).fill("neutral")
//   ];

//   return (
//     <div style={{ width: 220 }}>
//       <h4 style={{ textAlign: "center" }}>{title}</h4>

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(10, 1fr)",
//           gap: 4
//         }}
//       >
//         {cells.map((c, i) => (
//           <div
//             key={i}
//             style={{
//               width: 18,
//               height: 18,
//               borderRadius: 3,
//               background:
//                 c === "positive"
//                   ? "#4CAF50"
//                   : c === "negative"
//                   ? "#F44336"
//                   : "#E0E0E0"
//             }}
//           />
//         ))}
//       </div>

//       <div style={{ marginTop: 8, fontSize: 12, textAlign: "center" }}>
//         <span style={{ color: "#4CAF50" }}>■</span> {positive}% &nbsp;
//         <span style={{ color: "#F44336" }}>■</span> {negative}%
//       </div>
//     </div>
//   );
// }

import React from "react";

const GRID_SIZE = 100;

// COLOR PALETTE FOR TOTAL PARTICIPATION
const TOTAL_COLORS = [
  "#A81026", "#F15C41", "#F3AC26",
  "#6C6E2E", "#3B231E", "#4CBFAB",
  "#29002D", "#326AB3"
];

// COLORS FOR POS / NEG
const POS_COLOR = "#6C6E2E";
const NEG_COLOR = "#A81026";
const NEUTRAL_COLOR = "#E0E0E0";

export default function WaffleChart({
  title,
  positive = 0,
  negative = 0,
  mode = "posneg",   // "posneg" | "total"
  data = []          // [{ label, value }]
}) {

  let cells = [];

  // =====================================================
  // 🧇 MODE 1: POSITIVE / NEGATIVE WAFFLE
  // =====================================================
  if (mode === "posneg") {
    const posCount = Math.round(positive);
    const negCount = Math.round(negative);
    const neutralCount = Math.max(0, GRID_SIZE - posCount - negCount);

    cells = [
      ...Array(posCount).fill({ color: POS_COLOR }),
      ...Array(negCount).fill({ color: NEG_COLOR }),
      ...Array(neutralCount).fill({ color: NEUTRAL_COLOR })
    ];
  }

  // =====================================================
  // 🧇 MODE 2: TOTAL PARTICIPATION WAFFLE (✔ FIXED)
  // =====================================================
  if (mode === "total") {
    let filled = 0;

    // 1️⃣ Fill department participation (percent of TOTAL)
    data.forEach((d, i) => {
      const color = TOTAL_COLORS[i % TOTAL_COLORS.length];
      const count = Math.round(d.value || 0);

      for (let j = 0; j < count && filled < GRID_SIZE; j++) {
        cells.push({ color });
        filled++;
      }
    });

    // 2️⃣ Fill remaining blocks as "no participation"
    while (cells.length < GRID_SIZE) {
      cells.push({ color: NEUTRAL_COLOR });
    }
  }

  return (
    <div style={{ width: 260 }}>
      <h4 style={{ textAlign: "center", marginBottom: 8 }}>{title}</h4>

      {/* 🧇 WAFFLE GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(10, 1fr)",
          gap: 6
        }}
      >
        {cells.map((c, i) => (
          <div
            key={i}
            style={{
              width: 22,        // ⬆ large blocks (as requested)
              height: 22,
              borderRadius: 4,
              backgroundColor: c.color
            }}
          />
        ))}
      </div>

      {/* 📊 LEGEND */}
      {mode === "posneg" && (
        <div style={{ marginTop: 10, fontSize: 13, textAlign: "center" }}>
          <span style={{ color: POS_COLOR, fontWeight: "bold" }}>■</span>{" "}
          Positive {positive}% &nbsp;
          <span style={{ color: NEG_COLOR, fontWeight: "bold" }}>■</span>{" "}
          Negative {negative}%
        </div>
      )}

      {mode === "total" && (
        <div style={{ marginTop: 10, fontSize: 13 }}>
          {data.map((d, i) => (
            <div key={d.label} style={{ marginBottom: 4 }}>
              <span
                style={{
                  color: TOTAL_COLORS[i % TOTAL_COLORS.length],
                  fontWeight: "bold"
                }}
              >
                ■
              </span>{" "}
              {d.label} – {d.value}%
            </div>
          ))}
          <div style={{ marginTop: 6, color: "#666" }}>
            <span style={{ fontWeight: "bold" }}>■</span> No response
          </div>
        </div>
      )}
    </div>
  );
}

